import { useDispatch } from 'react-redux';
import Modal from '../custom/Modal';
import ModalClose from './ModalClose';
import { useAppTranslation } from '../../i18n';
import React from 'react';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';
import XS2ATermsModalCustomization from '../customizations/XS2ATermsModalCustomization';

const XS2ATermsModal = () => {
	const dispatch = useDispatch();
	const { t } = useAppTranslation();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.XS2ATERMS_MODAL));
	};
	return (
		<Modal onClose={handleOnCloseModal} ariaLabel={t('footer.conditions')}>
			<ModalClose onClose={handleOnCloseModal} />
			<XS2ATermsModalCustomization />
		</Modal>
	);
};

export default XS2ATermsModal;
